module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAABHNCSVQICAgIfAhkiAAAAMRJREFUOI2t1EuxAjEQheGPh4BIGAmDg5GAA3BwcQAScAAoAAcgAQd3JFx2sIJFsqCo4ZFLTlWvcvpPdyfVA91qsMUFxyeej1Vhn0BNCdgKLabfwnpY4Eesbom/jPyTjvEMxTZDumCUAQyoxS7n2DwamnTjPplyVGEnjq9TU3Guq1RJjtbiKDsV0mGLcQY0pJzQe2Mi7+HWOAxeGM4pclQj9DOTPlJpaI1DaWBbEljhV4F9QfwhE092xgzXf0Qr7ovqHnYDwB4vV+eoRJoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = 902
// module chunks = 0